{
  "title": "Paiements",
  "subtitle": "Chaque paiement, remboursement et annulation, avec ce qui est entré par moyen.",
  "providers": {
    "test": "Prestataire de paiement de test"
  },
  "kinds": {
    "payment": "Paiement",
    "refund": "Remboursement",
    "void": "Annulation"
  },
  "card": {
    "title": "Paiements",
    "total": "Total",
    "paid": "Payé",
    "refunded": "Remboursé",
    "due": "Reste dû",
    "codTitle": "Livrée, en attente du livreur",
    "codText": "Le livreur a encaissé : enregistrez son règlement quand il le verse.",
    "codLink": "Enregistrer le règlement",
    "draft": "Les paiements viennent une fois la commande passée.",
    "none": "Aucun paiement pour l’instant."
  },
  "entry": {
    "settled": "Règlement du livreur",
    "voided": "Annulé",
    "refunded": "Remboursé",
    "refundedPart": "{{amount}} remboursés",
    "cash": "Remis {{tendered}}, monnaie {{change}}",
    "left": "{{amount}} encore remboursables",
    "actions": "Actions sur ce paiement"
  },
  "take": {
    "action": "Encaisser",
    "title": "Paiement de {{number}}",
    "due": "Reste dû : {{amount}}. Plusieurs paiements font un paiement fractionné.",
    "method": "Moyen de paiement",
    "amount": "Montant",
    "tooMuch": "Plus que les {{amount}} restant dus",
    "tendered": "Espèces remises",
    "tenderedHint": "Laissez vide si c’est le montant exact.",
    "references": {
      "card": "Numéro du ticket carte",
      "cheque": "Numéro du chèque",
      "transfer": "Référence du virement"
    },
    "bank": "Banque",
    "chequeDate": "Date du chèque",
    "change": "Monnaie à rendre",
    "note": "Note",
    "confirm": "Enregistrer {{amount}}",
    "doneLeft": "Paiement enregistré, {{amount}} restent dus",
    "donePaid": "La commande {{number}} est payée"
  },
  "refund": {
    "action": "Rembourser",
    "title": "Rembourser un paiement",
    "of": "Paiement {{method}} de {{amount}}, {{date}}. L’argent repart par le même moyen.",
    "amount": "Montant à rendre",
    "left": "Jusqu’à {{amount}} sur ce paiement.",
    "tooMuch": "Plus que les {{amount}} restant sur ce paiement",
    "for": "Pour",
    "noReturn": "Sans retour (un geste, une correction de prix)",
    "return": "Le retour du {{date}} · {{reason}}",
    "creditNote": "La commande a une facture : ce remboursement reçoit son propre avoir.",
    "note": "Note",
    "confirm": "Rembourser",
    "done": "{{amount}} remboursés",
    "provider": "Le prestataire de paiement recrédite la carte du client."
  },
  "void": {
    "action": "Annuler",
    "title": "Annuler le paiement {{method}} de {{amount}} ?",
    "text": "Pour un paiement saisi par erreur. Il reste au journal, marqué annulé, et ne compte plus.",
    "reason": "Pourquoi",
    "confirm": "Annuler le paiement",
    "done": "Paiement annulé"
  },
  "invoice": {
    "action": "Émettre la facture",
    "title": "Facture de {{number}}",
    "fromCustomer": "Les coordonnées de l’acheteur viennent de la fiche client. Saisissez-en d’autres pour les remplacer sur cette facture.",
    "noCustomer": "La commande n’a pas de client : saisissez les coordonnées de l’acheteur.",
    "final": "Une facture est définitive : elle prend le numéro suivant et seule sa date peut encore changer. Les retours et remboursements qui suivent reçoivent des avoirs.",
    "buyerName": "Acheteur",
    "buyerTaxId": "Matricule fiscal de l’acheteur",
    "buyerAddress": "Adresse de l’acheteur",
    "confirm": "Émettre la facture",
    "done": "Facture {{number}} émise",
    "date": "Date de la facture",
    "dateHint": "Pas avant la dernière facture : les dates suivent les numéros."
  },
  "documents": {
    "title": "Documents",
    "none": "Pas encore de facture. Émettez-la quand le client la demande."
  },
  "cod": {
    "title": "Contre-remboursement",
    "subtitle": "Les commandes livrées dont le livreur détient encore l’argent. Enregistrez ce qu’il verse.",
    "emptyTitle": "Rien en attente",
    "emptyText": "Toutes les commandes en contre-remboursement sont réglées.",
    "pending_one": "{{count}} commande · {{amount}} à encaisser",
    "pending_other": "{{count}} commandes · {{amount}} à encaisser",
    "carrier": "Livreur",
    "allCarriers": "Tous les livreurs",
    "noCarrier": "Sans livreur",
    "carrierCount": "{{name}} ({{count}})",
    "pickCarrier": "Choisir le livreur",
    "noCarriers": "Aucun transporteur n’encaisse le contre-remboursement : ajoutez-en un dans Configuration › Transporteurs.",
    "pickAll": "Cocher toutes celles affichées",
    "pick": "Cocher {{number}}",
    "late_one": "{{count}} jour",
    "late_other": "{{count}} jours",
    "shipped": "expédiée le {{date}}",
    "amountOf": "Montant versé pour {{number}}",
    "amountWrong": "Entre 0 et {{amount}}",
    "settlement": "Règlement",
    "settlementHint": "Un règlement par relevé du livreur : chaque commande cochée reçoit son paiement.",
    "reference": "Référence du relevé",
    "referenceHint": "Le numéro du relevé ou du virement du livreur.",
    "receivedOn": "Reçu le",
    "orders_one": "{{count}} commande",
    "orders_other": "{{count}} commandes",
    "confirm": "Enregistrer le règlement",
    "done_one": "{{amount}} de {{carrier}} enregistrés sur {{count}} commande",
    "done_other": "{{amount}} de {{carrier}} enregistrés sur {{count}} commandes"
  },
  "journal": {
    "from": "Du",
    "to": "Au",
    "method": "Moyen",
    "allMethods": "Tous les moyens",
    "site": "Site",
    "allSites": "Tous les sites",
    "clear": "Effacer les filtres",
    "inOut": "Entré {{received}} · sorti {{refunded}}",
    "net": "Net encaissé",
    "noMatch": "Aucun paiement ne correspond à ces filtres",
    "emptyTitle": "Aucun paiement pour l’instant",
    "emptyText": "Les paiements enregistrés sur les commandes apparaissent ici.",
    "columns": {
      "when": "Quand",
      "order": "Commande",
      "what": "Quoi",
      "reference": "Référence",
      "site": "Site",
      "by": "Par",
      "amount": "Montant (TND)"
    },
    "more": "Voir plus"
  },
  "customer": {
    "title": "Enregistrer un paiement",
    "date": "Date",
    "dateHint": "Le jour où l’argent est arrivé.",
    "tillDate": "Une caisse encaisse l’argent du jour.",
    "orders": "Commandes payées",
    "ordersHint": "Cochez des commandes et le montant suit, ou tapez le montant et répartissez-le sur les plus anciennes.",
    "shareOldest": "Répartir sur les plus anciennes",
    "openAmount": "{{amount}} restent dus",
    "shareOf": "Part de {{number}}",
    "otherMethod": "Cette commande ne prend pas ce moyen",
    "shared": "Réparti",
    "toShare": "Reste à répartir",
    "overShared": "Plus que le montant",
    "noAdvance": "Tout va aux commandes : un client ne garde pas d’avance.",
    "done_one": "Paiement enregistré sur {{count}} commande",
    "done_other": "Paiement enregistré sur {{count}} commandes",
    "voidText": "Pour un paiement pris par erreur. Il est retiré de chaque commande payée, reste au journal marqué annulé et ne compte plus."
  }
}
